module.exports = __webpack_public_path__ + "components/page-footer/static/weather-forecast__logo--white-4cf2d1bd3d388ffea7819bdc41946592.png";